import React, { Component } from "react";
import { ModalContent, Modal } from "semantic-ui-react";
import NewCourse from "../Courses/NewCourse";
import { CourseResource } from "../../../../stores/CoursesStore/Types";
import { randomTexts } from "./helper";

interface Props {
  openModal: boolean;
  onClickCloseModal: () => void;
  courses: CourseResource[];
  loading: boolean;
  commentary: string;
  errorMessage: string;
  roleText: string;
  goalText: string;
  userIsInUk: boolean;
}

interface State {
  randomText: string;
}

class CoursesModal extends Component<Props, State> {
  interval: NodeJS.Timeout | null = null;

  constructor(props) {
    super(props);

    this.state = {
      randomText: randomTexts[0],
    };
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      const randomIndex = Math.floor(Math.random() * randomTexts.length);
      this.setState({ randomText: randomTexts[randomIndex] });
    }, 2000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  onCloseModal = () => {
    this.props.onClickCloseModal();
  };

  render() {
    const {
      openModal,
      commentary,
      courses,
      loading,
      roleText,
      goalText,
      userIsInUk,
    } = this.props;
    const { randomText } = this.state;

    return (
      <Modal
        className="ai-course-picker-modal"
        size="large"
        open={openModal}
        onClose={this.onCloseModal}
      >
        <button
          aria-label="Close course recommendations"
          className="ai-course-picker-modal__close"
          onClick={this.onCloseModal}
          type="button"
        >
          &times;
        </button>
        <div className="courses ai-course-picker-modal__inner">
          {loading ? (
            <ModalContent className="loading-content">
              <div className="ai-course-picker-modal__loading">
                <div className="ai-course-picker-modal__header">
                  <div className="ai-course-picker-modal__eyebrow">
                    Course finder
                  </div>
                  <h2 className="ai-course-picker-modal__title">
                    Finding your course matches
                  </h2>
                  <div className="random-text">{randomText}</div>
                </div>
                <div
                  aria-label="Loading course recommendations"
                  className="ai-course-picker-modal__loader"
                  role="status"
                >
                  <span />
                </div>
              </div>
            </ModalContent>
          ) : (
            <ModalContent
              className="ai-course-picker-modal__content"
              scrolling={courses.length > 3}
            >
              <div className="courses-container center aligned">
                <div className="ai-course-picker-modal__header">
                  <div className="ai-course-picker-modal__eyebrow">
                    Course finder results
                  </div>
                  <h2 className="ai-course-picker-modal__title">
                    A few courses that should fit nicely
                  </h2>
                  <div className="search-text text-color">
                    I am a <strong>{roleText}</strong> and I want to{" "}
                    <strong>{goalText}</strong>
                  </div>
                </div>
                {courses.length > 0 ? (
                  <>
                    <div className="commentary text-color">{commentary}</div>
                    <div
                      className="course-grid ai-picker-results-grid"
                      id="courses_grid"
                    >
                      {courses?.map((course, i) => (
                        <NewCourse
                          courseResource={course}
                          key={course.id}
                          userIsInUk={userIsInUk}
                          cardClass={i === 0 ? "top-pick" : ""}
                        />
                      ))}
                    </div>
                  </>
                ) : (
                  <div className="font-18 text-color">No results found!!!</div>
                )}
              </div>
            </ModalContent>
          )}
        </div>
      </Modal>
    );
  }
}

export default CoursesModal;
